import Badge from '@material-ui/core/Badge';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

import * as colors from '../../../styles/colors';

const ClusterMarker = ({ color, count, fillPercentage, cardinal, onClick }) => {
  const classes = useStyles({ color, timeRemainingPercentage: fillPercentage });
  const component = (
    <div className={classes.root} onClick={onClick}>
      <Typography display='block'>{count}</Typography>
      <div className={classes.progressContainer}>
        {
          (color === colors.markers.property.LOW_PRIORITY && fillPercentage < 100) ? (
            <LinearProgress
              className={classes.linearProgress}
              classes={{ barColorPrimary: classes.linearProgressBar }}
              value={fillPercentage}
              variant='determinate'
            />
          ) : (
            <div
              style={{
                height: '100%',
                borderRadius: 4,
                backgroundColor: color
              }}
            />
          )
        }
        <div className={classes.textContainer}>
          <Typography>{count}</Typography>
        </div>
      </div>
    </div>
  );
  return (
    <div className={classes.absolutePosition}>
      {cardinal ? (
        <Badge
          classes={{ anchorOriginTopRightRectangle: classes.badge }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          badgeContent={<span>VIP</span>}
          color='primary'
          invisible={false}
          overlap='rectangle'
        >
          {component}
        </Badge>
      ) : (
        component
      )}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  absolutePosition: {
    position: 'absolute',
    transform: 'translate(-50%,-50%)'
  },
  root: {
    position: 'relative',
    padding: '0 4px',
    color: 'white',
    fontSize: 16,
    cursor: 'pointer'
  },
  badge: {
    height: 14,
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: 10,
    color: colors.WHITE,
    backgroundColor: 'goldenrod',
    transform: props => props.isPatrol ? 'translate(20%, -70%)' : 'translate(16%, -70%)'
  },
  progressContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  },
  linearProgress: {
    height: '100%',
    borderRadius: 4,
    backgroundColor: '#121212'
  },
  linearProgressBar: {
    backgroundColor: props => props.color
  },
  textContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export default ClusterMarker;